module.exports = __webpack_public_path__ + "img/vertical_3_6_3009.98eaf728.png";